import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	title: {
		id: 'admin-pages-priority-schemes.title',
		defaultMessage: 'Priority schemes',
		description: 'Document title for priority schemes global admin page',
	},
	errorHeader: {
		id: 'admin-pages-priority-schemes.error-header',
		defaultMessage: 'There was a problem loading this page',
		description: 'Error header in priority schemes global admin page',
	},
	errorDescription: {
		id: 'admin-pages-priority-schemes.error-description',
		defaultMessage: 'Check your connection and try again',
		description: 'Error content for priority schemes global admin page',
	},
});

export default messages;
